import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GOOGLE_ANALYTICS_SETTINGS_TOKEN } from './constants';
import { IGoogleAnalyticsSettings } from './interfaces/IGoogleAnalyticsSettings';
import { GOOGLE_ANALYTICS_INITIALIZER_PROVIDER } from './providers/google-analytics.initializer';

/**
  Google Analytics
  
  Utilisation :
  ** Importer le module GoogleAnalyticsModule
  ```
  // app.module.ts
  ...
  imports: [
   ...
   GoogleAnalyticsModule.forRoot({ trackingCode: environment.gaTrackingCode }),
   ...
  ]
  ```
  
  ** Si un routeur, importer le module GoogleAnalyticsRouterModule
  ```
  // app.module.ts
  ...
  imports: [
   ...
   GoogleAnalyticsModule.forRoot({ trackingCode: environment.gaTrackingCode }),
   GoogleAnalyticsRouterModule
   ...
  ]
  ```

  Si aucun trackingCode enregistré, le module emet un warning dans la console, et n'enverra rien à Google Analytics.
  
  ** Utilisation du service
  importer dans le constructeur `gaService: GoogleAnalyticsService`
  Pour appeler un event : gaService.event(...)
  Pour appeler un page_view : gaService.pageView(...)
  Pour désactiver analytics : gaService.enableAnalytics(false)
 */

@NgModule({
  imports: [
    CommonModule
  ],
})
export class GoogleAnalyticsModule { 
    static forRoot(options: IGoogleAnalyticsSettings):ModuleWithProviders<GoogleAnalyticsModule>{
        return {
            ngModule: GoogleAnalyticsModule,
            providers: [
                {
                    provide: GOOGLE_ANALYTICS_SETTINGS_TOKEN,
                    useValue: options
                },
                GOOGLE_ANALYTICS_INITIALIZER_PROVIDER
            ]
        }
    }
}
